export default "__VITE_ASSET__CADoYWJX__"